import styled, { space } from "@styled";

export const SocialWrap = styled.div`
    ${space};
`;
